<template>
    <div class="flex items-center justify-between p-6 border-b border-gray-200">
        <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <ExclamationTriangleIcon class="h-6 w-6 text-red-600" />
            </div>
            <h2 class="text-xl font-semibold text-gray-900">Delete Account</h2>
        </div>
        <button
            @click="$emit('closeDialog')"
            class="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
        >
            <XMarkIcon class="h-5 w-5" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline';

defineEmits<{
    closeDialog: []
}>();
</script> 